export default "__VITE_ASSET__CULLhcFa__"